const USER_STORAGE_KEY = "user";
const TOKEN_STORAGE_KEY = "authToken";

export function getStoredUser() {
    try {
        const raw = localStorage.getItem(USER_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.error("No se pudo leer la sesion guardada:", error);
        return null;
    }
}

export function setSessionData(user, token) {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
    if (token) {
        localStorage.setItem(TOKEN_STORAGE_KEY, token);
    }
}

export function clearSessionData() {
    localStorage.removeItem(USER_STORAGE_KEY);
    localStorage.removeItem(TOKEN_STORAGE_KEY);
}

export function hasSession() {
    return Boolean(getStoredUser());
}
